import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EvaluationService } from 'src/app/core/services/evaluation.service';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-evaluation-details',
  templateUrl: './evaluation-details.component.html',
  styleUrls: ['./evaluation-details.component.scss']
})
export class EvaluationDetailsComponent implements OnInit {
  tenderData: any = null; // Holds tender data
  noData: boolean = false; // Flag for missing data
  currentDate: Date = new Date();

  constructor(public userUtilsService:UserUtilService, private router: Router, private evalService: EvaluationService) {}

  ngOnInit(): void {
    this.tenderData = this.evalService.getEvalData();

    debugger

    if (!this.tenderData) {
      this.noData = true;
    }
  }

  goBack() {
    this.router.navigate(['/tender']); // Navigate back
  }

  printInvoice() {
    const invoice = document.getElementById('invoiceSection');
    const printTime = new Date().toLocaleString();
    const printUrl = window.location.href;

    // Fill the placeholders
    const timeElem = document.getElementById('printTime');
    const urlElem = document.getElementById('printUrl');

    if (timeElem && urlElem) {
      timeElem.innerText = `${printTime}`;
      urlElem.innerText = `${printUrl}`;
    }

    const originalContents = document.body.innerHTML;

    if (invoice) {
      document.body.innerHTML = invoice.innerHTML;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // optional: reloads Angular app state
    }
  }

}
